export default class CartValidateButton extends HTMLAnchorElement {

    connectedCallback() {
        this.addEventListener('click', (e) => {
            if (this.dataset.submitting) {
                e.preventDefault();

                return;
            }

            this.dataset.submitting = 'true';
            this.classList.add('disabled');
        });
    }
}
